import axios from "axios";
import { API_URL } from "../../const";

/*************** FUNDER DETAILS ADD START *************** */
export const funderDetailsAdd = (addData: any) => {
  const data = {
    CreateFunderToken: addData,
  };
  const url = `${API_URL}CreateFunder`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** FUNDER DETAILS ADD END *************** */

/*************** FUNDER DETAILS UPDATE START *************** */
export const funderDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateFunderDetailsToken: updateData,
  };
  const url = `${API_URL}UpdateFunder`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** FUNDER DETAILS UPDATE END *************** */

/*************** FUNDER DETAILS GET START *************** */
export const funderListGet = (listData: any) => {
  const data = {
    GetAllFunderPaginationToken: listData,
  };
  const url = `${API_URL}GetAllFunderDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** FUNDER DETAILS GET END *************** */

/*************** FUNDER DETAILS FETCH START *************** */
export const funderDetailsFetch = (fetchData: any) => {
  const data = {
    FetchFunderDetailsToken: fetchData,
  };
  const url = `${API_URL}FetchFunderDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** FUNDER DETAILS FETCH END *************** */

/*************** FUNDER DETAILS DELETE START *************** */
export const funderDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteFunderToken: deleteData,
  };
  const url = `${API_URL}DeleteFunder`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** FUNDER DETAILS DELETE END *************** */

/** *************** START FUNDER LIST FETCH DETAILS ***************** */

export const fetchListFunder = (fetchData: JSON) => {
  const data = {
    AllFunderMasterToken: fetchData,
  };

  const url = `${API_URL}GetAllFunderMaster`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END FUNDER LIST FETCH DETAILS ***************** */
